// hooks/useTokenRefresh.ts
'use client'

import { useEffect } from 'react'

export function useTokenRefresh() {
  useEffect(() => {
    const interval = setInterval(async () => {
      try {
        const res = await fetch('/api/refresh', { method: 'POST' })
        if (!res.ok) throw new Error('Token não pôde ser renovado')
        console.log('[auth] token renovado com sucesso')
      } catch (e) {
        console.warn('[auth] falha ao renovar token:', e)
      }
    }, 5 * 60 * 1000)

    return () => clearInterval(interval)
  }, [])
}
